import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '分类', path: '/category/rexue' },
  { name: '排行榜', path: '/category/rexue' },
  { name: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
      role="navigation"
      aria-label="主导航"
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-book-open-line text-2xl text-primary-500"></i>
            </div>
            <span className="text-xl font-heading text-primary-600 tracking-wide">叮当漫画网</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path + link.name}
                to={link.path}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-primary-500'
                    : scrolled || !isHome
                      ? 'text-foreground-700 hover:text-primary-500'
                      : 'text-white/90 hover:text-white'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button
              className="relative w-9 h-9 flex items-center justify-center rounded-full bg-background-100/80 hover:bg-background-200 cursor-pointer transition-colors"
              aria-label="搜索"
            >
              <i className="ri-search-line text-foreground-600 text-lg"></i>
            </button>
            <Link
              to="/comic/dahuang-yatou"
              className="flex items-center gap-1.5 px-4 py-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line text-base"></i>
              开始阅读
            </Link>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="打开菜单"
          >
            <i
              className={`text-2xl ${
                scrolled || !isHome ? 'text-foreground-800' : 'text-white'
              } ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}
            ></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 shadow-lg">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.path + link.name}
                to={link.path}
                className={`text-sm font-medium py-2 px-3 rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-primary-500 bg-primary-50'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/comic/dahuang-yatou"
              className="flex items-center justify-center gap-1.5 px-4 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer mt-2"
            >
              <i className="ri-play-circle-line text-base"></i>
              开始阅读
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}